import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import pluralize from 'utils/pluralize';

const noOp = () => {};

export default TYPE => {
    const PLURAL = pluralize(TYPE);

    const actions = {
        changeSearch: searchValue => ({
            type: `CHANGE_${PLURAL}_SEARCH`,
            payload: searchValue
        }),

        changeSort: ({ sortBy, sortDirection }) => ({
            type: `CHANGE_${PLURAL}_SORT`,
            payload: {
                sortBy,
                sortDirection
            }
        }),

        create: (data, redirect) => ({
            type: `CREATE_${TYPE}`,
            payload: data,
            meta: redirect
        }),

        remove: (id, redirect) => ({
            type: `DELETE_${TYPE}`,
            payload: id,
            meta: redirect || noOp
        }),

        fetchAll: (params, meta) => ({
            type: `FETCH_${PLURAL}`,
            payload: params,
            meta: meta
        }),

        fetchOne: id => ({
            type: `FETCH_${TYPE}`,
            payload: id
        }),

        update: (id, data, redirect) => ({
            type: `UPDATE_${TYPE}`,
            payload: { id, data },
            meta: redirect
        }),

        toggleAll: () => ({
            type: `TOGGLE_ALL_${PLURAL}`
        }),

        toggleOne: id => ({
            type: `TOGGLE_ONE_${TYPE}`,
            payload: id
        })
    };

    const useActions = {
        useChangeSearch: () => {
            const dispatch = useDispatch();
            return useCallback(searchValue => {
                dispatch(actions.changeSearch(searchValue));
            }, [dispatch]);
        },
        useChangeSort: () => {
            const dispatch = useDispatch();
            return useCallback(({ sortBy, sortDirection }) => {
                dispatch(actions.changeSort({ sortBy, sortDirection }));
            }, [dispatch]);
        },
        useCreate: () => {
            const dispatch = useDispatch();
            return useCallback((data, redirect) => {
                dispatch(actions.create(data, redirect));
            }, [dispatch]);
        },
        useRemove: () => {
            const dispatch = useDispatch();
            return useCallback((id, redirect) => {
                dispatch(actions.remove(id, redirect));
            }, [dispatch]);
        },
        useFetchAll: () => {
            const dispatch = useDispatch();
            return useCallback((params, meta) => {
                dispatch(actions.fetchAll(params, meta));
            }, [dispatch]);
        },
        useFetchOne: () => {
            const dispatch = useDispatch();
            return useCallback(id => {
                dispatch(actions.fetchOne(id));
            }, [dispatch]);
        },
        useUpdate: () => {
            const dispatch = useDispatch();
            return useCallback((id, data, redirect) => {
                dispatch(actions.update(id, data, redirect));
            }, [dispatch]);
        },
        useToggleAll: () => {
            const dispatch = useDispatch();
            return useCallback(() => {
                dispatch(actions.toggleAll());
            }, [dispatch]);
        },
        useToggleOne: () => {
            const dispatch = useDispatch();
            return useCallback(id => {
                dispatch(actions.toggleOne(id));
            }, [dispatch]);
        }
    };

    return {
        ...actions,
        ...useActions
    };
};
